<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
							<div class="col">
							<button type="button" class="close" @click="$emit('closeModal')">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body">
							<h4 class="title">Set Harga Sparepart</h4>

            

              <div>
                <h5>Nama Sparepart : {{data.priceList.sparepart_name}}</h5>
                <h5>Qty : {{data.priceList.quantity}}</h5>

                <!-- <template v-if="data.priceList.supplier_prices.length > 0">
                  <div v-for="(dat , index) in data.priceList.supplier_prices" class="mt-3 border border-secondary rounded p-10 row" :class="{'bg-yellow' : index == priceIndex}">
                    <div class="col-8 col-md-10">
                      <h6>Supplier {{index + 1}} - {{data.type == 'P' ? dat.supplier_id ? $store.getters.getSupplierNameById(dat.supplier_id) : 'Nego Asuransi' : '-'}}</h6>

                      Inden : {{dat.inden}} hari<br>
                      Harga Sparepart : Rp {{numberWithCommas(parseFloat(dat.price_per_item) )}} <br>
                      Total Yang Akan Ditagih : Rp {{numberWithCommas((parseFloat(dat.price_per_item)) * data.priceList.quantity)}}<br>
                    </div>
                    <div class="col-4 col-md-2 mt-auto mb-auto">
                      <button class="btn btn-info w-100" type="button" @click="priceIndex = index;priceSelected = true">Pilih</button>
                    </div>
                  </div>
                </template> -->
                <!-- Temporary Price -->
                <template>
                  <div class="mt-3">
                    <div class="text-left">
                      <!-- <h5>Harga belum di masukkan di Parts Quotation</h5> -->
                    </div>
                  </div>
                  <div class="mt-2">
                    <div class="input-group">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div>
                          <label class="label">Input Harga / Item Sementara<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text"  v-model="temporaryPrice">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitTempPrice">Selesai</button>
                    </div>
                  </div>
                </template>
              </div>

              <div v-if="priceSelected" class="mt-3" style="overflow:scroll;width:100%">
                <hr>
                <h4>Konfirmasi Pemilihan Harga</h4>

                <table class="table table-borderless">
                  <tr>
                    <td>Total Harga Barang</td>
                    <td>:</td>
                    <td>Rp {{numberWithCommas((parseFloat(data.priceList.supplier_prices[priceIndex].price_per_item)) * data.priceList.quantity )}}</td>
                  </tr>

                  <tr v-if="data.type == 'P'">
                    <td>Inden Barang</td>
                    <td>:</td>
                    <td>{{data.priceList.supplier_prices[priceIndex].inden}} Hari</td>
                  </tr>

                  <tr v-if="data.type == 'P'">
                    <td>Pricelist Supplier per Barang</td>
                    <td>:</td>
                    <td>Rp {{data.priceList.supplier_prices[priceIndex].supplier_pricelist}}</td>
                  </tr>

                  <tr v-if="data.type == 'P'">
                    <td>Diskon Supplier</td>
                    <td>:</td>
                    <td>{{data.priceList.supplier_prices[priceIndex].supplier_discount}}</td>
                  </tr>
                </table>
                <div class="row text-left">
                  <div class="col-12">
                    <div class="input-group">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div>
                          <label class="label">Harga Penagihan<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text"  v-model="markupPrice">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12" v-if="lowestPriceNotChosen">
                    <div class="input-group">
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div>
                          <label class="label">Alasan Tidak Memilih<br> Harga Terendah<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text"  v-model="description">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-5" style="text-align: center">
                    <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                    <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitPrice(priceIndex)">Selesai</button>
                  </div>
                </div>
              </div>
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
	data () {
		return {
      data : null,
      priceSelected : false,
      priceIndex : null,
      markupPrice : '',
      tempPrice : '',
      lowestIndex : 0,
      description : '',
      temporaryPrice : 0
     
		}
  },
	props : ['showData'],
	components : {
		MultiSelect
	},
  created () {
    
  },
	mounted () {
    this.data = JSON.parse(JSON.stringify(this.showData))
    console.log(this.data)
    this.getIndividualPPN()
    this.determineLowestIndexPrice();
  },
  computed : {
    lowestPriceNotChosen () {
      return (this.priceSelected && this.priceIndex != this.lowestIndex) ? true : false
    },  
  },
  watch : {
    'temporaryPrice' : function () {

        const result = this.temporaryPrice.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.temporaryPrice = result);
    },
    'markupPrice' : function () {
        let total = 0
        if(this.markupPrice && this.markupPrice.includes('%')) {
          let discount = parseFloat(this.markupPrice.split('%')[0]) / 100
          total = Math.round(parseFloat(this.tempPrice.split(',').join('')) * (1 + discount)).toString()
        }
        else {
          total = this.markupPrice
        }

        console.log(total)

        const result = total.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.markupPrice = result);
        
        
    },
    priceIndex : function () {
      if(!this.priceSelected)
        return
      // console.log(this.priceIndex)
      let data = this.data.priceList.supplier_prices[this.priceIndex] 
      // console.log((parseFloat(data.supplier_pricelist.split(',').join('')) * parseFloat(this.data.priceList.quantity)))

      this.markupPrice = (parseFloat(data.supplier_pricelist.split(',').join('')) * parseFloat(this.data.priceList.quantity)).toString()

      // console.log(data)

      // if(!data.without_ppn) {
      //   if(data.ppn_included == 1) {
      //     this.markupPrice = this.markupPrice / 1.1
      //   }
      //   else {
      //     this.markupPrice = this.markupPrice * 1.1
      //   }
      // }
      
      this.tempPrice = this.numberWithCommas(this.markupPrice)
    },
  },
	methods : {
    getIndividualPPN () {
      for(var i = 0 ; i  < this.data.priceList.supplier_prices.length ; i++) {
        let curData = this.data.priceList.supplier_prices[i]
        // console.log(curData)

        if(curData.without_ppn) continue;

        if(curData.ppn_included == 1) {
          curData.price_per_item = parseFloat(curData.price_per_item) / 1.1
        }
        else {
          curData.price_per_item = parseFloat(curData.price_per_item) * 1.1
        }
      }
    },
    determineLowestIndexPrice () {
      if(this.data.priceList.supplier_prices.length <= 0) return
      let lowestIndex = 0;
      let lowestPrice = this.data.priceList.supplier_prices[0].price_per_item;


      this.data.priceList.supplier_prices.forEach((priceItem, index)=>{
        let currentPrice = (parseFloat(priceItem.price_per_item)) * this.data.priceList.quantity
        if (currentPrice < lowestPrice) {
          lowestIndex = index;
          lowestPrice = currentPrice;
        }
      })
      
      this.lowestIndex = lowestIndex;
    },
    submitTempPrice() {
      if(this.temporaryPrice == '') {
        this.$store.dispatch('triggerAlert' , [false , 'Harga Sementara Wajib Diisi'])
        return
      }
      // console.log(this.data)

      let data = {
        estimated_price : parseFloat(this.temporaryPrice.split(',').join(''))
      }
      this.$http
				.patch("/api/v1/estimations/" + this.data.id, data)
				.then((resp) => {
					this.$store.dispatch('triggerAlert', [true, [`Harga Sementara Berhasil Ditambah`]]);
          this.$emit('updateEstimation')
          this.$emit('closeModal')

				})
				.catch((err) => {
					console.log(err);
				});


    },
		submitPrice(index) {
      if(this.markupPrice == '') {
        this.$store.dispatch('triggerAlert' , [false , 'Markup Harga Barang Wajib di Isi'])
        return
      }

      let priceData = this.data.priceList.supplier_prices[index]
      // console.log( parseFloat(this.markupPrice.split(',').join('')) , (parseFloat(priceData.price_per_item) * this.data.priceList.quantity))
      priceData.markupPrice = (parseFloat(this.markupPrice.split(',').join('')) - (parseFloat(priceData.price_per_item) * this.data.priceList.quantity)) / this.data.priceList.quantity
      console.log(priceData.markupPrice)
      //index ,price.price_per_item , estimationPart.id
      if (this.lowestPriceNotChosen) 
        this.$emit("submit" , 'Supplier' , this.data.index , {id : priceData.id , markupPrice : priceData.markupPrice}, this.data.priceList.estimations_id, this.description )
      else
        this.$emit("submit" , 'Supplier' , this.data.index , {id : priceData.id , markupPrice : priceData.markupPrice}, this.data.priceList.estimations_id )
		}
	}
}
</script>

<style scoped>
  .estimation-sparepart-table thead tr th{
    text-align: center;
  }

  .estimation-sparepart-table tbody tr td{
    text-align: center;
    vertical-align: middle;
  }
  
  .clickAble:hover{
    cursor: pointer;
  }

  .bg-yellow {
    background-color : yellow;
  }
</style>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
